<template>
  <div class="pa-2">
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else-if="filteredTickets.length">
      <template v-for="ticket in filteredTickets">
        <ticket-item :key="ticket.id" :value="ticket"></ticket-item>
      </template>
    </div>
    <div v-else class="text-xs-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import TicketItem from './TicketItem'
export default {
  props: ['value', 'byadminid', 'filter'],
  components: {
    TicketItem,
  },
  data() {
    return {
      loading: false,
      tickets: [],
    }
  },
  async mounted() {
    this.loading = true
    if (this.byadminid) {
      var response = await this.getTicketByAdminId()
    } else {
      var response = await this.getTicketListByUser()
    }
    if (response.data && response.data.length > 0) {
      this.tickets = response.data
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
    }),
    filteredTickets() {
      var result
      if (this.$store.state.privilege) {
        switch (this.$store.state.privilege.view_ticket) {
          case 'all':
            result = this.tickets
            break
          case 'only_me':
            result = this.tickets.filter((el) => {
              return el.adminid == this.$store.state.userid
            })
            break
          case 'only_group':
            result = this.tickets.filter((el) => {
              return el.assigngroupid == this.$store.state.admingroupid
            })
            break
          case 'only_subgroup':
            result = this.tickets.filter((el) => {
              return el.assignsubgroupid == this.$store.state.adminsubgroupid
            })
            break
          default:
            result = []
        }
      } else {
        result = []
      }
      if (this.filter) {
        result = result.filter((el) => el.status == this.filter)
      }
      return result
    },
  },
  methods: {
    getTicketListByUser() {
      var data = {
        userid: this.value,
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getTicketListByUser(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTicketByAdminId() {
      var data = {
        adminid: this.value,
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getTicketByAdminId(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketList.vue